import {
  getPageType,
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { getUserDetails } from "../services/demogApi";
import { utlInsert, offerAPI, deleteFromCartApi } from "@repo/connection-manager";
import { commonInsertParameters, getOrDefaultValue } from "@repo/shared-utils/insert-params";
import { getApplicationIdAndProdCode, getApplicationId } from "./utils";
import type { SSORedirectHandler } from "../types/SSO.types";
import { PDP_DETAILS, WHEELS_OFFER } from "../../../api-client/src/constants/util";

const PRODUCT_MAPPING = {
  UTL_ALL: "UTL",
  UTL_LAT: "LAT",
  UTL_BT: "TBT",
  NTL_ALL: "NTL",
} as const;

const getProductConfig = (product: "UTL_ALL" | "UTL_LAT" | "UTL_BT" | "NTL_ALL") => {
  const productConfig = {
    NTL_ALL: {
      ...commonInsertParameters({
        appVersion: "v1",
        pwaVersion: "5.1.9",
      }),
      prodName: "NTL",
      apiVersion: "P.11.1.4",
    },
    default: {
      ...commonInsertParameters(),
      prodName: "UTL",
    },
  };

  return product === "NTL_ALL" ? productConfig.NTL_ALL : productConfig.default;
};

export const tfHandler: SSORedirectHandler = async (data) => {
  const { mobileNo } = await getSessionData();
  const product = getPageType("offer-identifier") as "UTL_ALL" | "UTL_LAT" | "UTL_BT" | "NTL_ALL";
  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, [product]);
  const userData = await getUserDetails(mobileNo);
  const custType = getOrDefaultValue(userData?.data?.custType, "NTB");
  let response;
  const resume = applicationID !== undefined;

  const appId = await getApplicationId([product]);
  if (appId) {
    await deleteFromCartApi({ appId, mobileNo, channel: "3in1" });
  }

  const offerProduct = product === "NTL_ALL" ? "NTL" : product;
  const [offer] = (await offerAPI(offerProduct)) ?? [];

  const config = getProductConfig(product);

  response = await utlInsert({
    mobileNo,
    custType,
    journeyName: product,
    eventCode: WHEELS_OFFER,
    eventName: PDP_DETAILS,
    offerId: offer?.offerId ?? "",
    offerName: offer?.offerName ?? "",
    offerAmt: offer?.icorsAmount ?? "",
    processType: offer ? "Pre Approved" : "Full Underwriting",
    ...data.data?.tfInsert,
    ...config,
  });

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  redirectToWebform(
    callbackUrl.toString(),
    {
      applicationID: response?.id ?? applicationID,
      custType,
      prodCode: response?.id ? "" : prodCode,
      product: PRODUCT_MAPPING[product],
      resume: false,
    },
    `tractor_loan/${resume ? "resume" : "new"}`
  );
};
